export default "__VITE_ASSET__sOKb9NZz__"